import {createAsyncThunk} from '@reduxjs/toolkit'
import {BILLING_CYCLE_ORDER_COUNTS_PATH} from 'src/app/pages/pricing-page/billingCycleOrderCountsApi'
import AxiosClient from '../AxiosClient'

export const requestSubscriptionAsync = createAsyncThunk(
  'auth/requestSubscriptionAsync',
  async (payload: any, toolkit) => {
    return await AxiosClient('POST', '/api/request-subscription', payload, toolkit, [])
  }
)

export const requestFreePlanForWoocom = createAsyncThunk(
  'auth/requestFreePlanForWoocom',
  async (payload: any, toolkit) => {
    return await AxiosClient('POST', '/api/activate-billing-plan/', payload, toolkit, [])
  }
)

export const cancelSubscriptionAsync = createAsyncThunk(
  'auth/cancelSubscriptionAsynccancelSubscriptionAsync',
  async (payload: any, toolkit) => {
    return await AxiosClient('POST', '/api/cancel-subscription', payload, toolkit, [])
  }
)

export const updateSubscriptionAsync = createAsyncThunk(
  'auth/updateSubscriptionAsync',
  async (payload: any, toolkit) => {
    return await AxiosClient('POST', '/api/change-subscription', payload, toolkit, [])
  }
)
//get all plans
export const getAllPlansAsync = createAsyncThunk(
  'auth/getAllPlansAsync',
  async (params: any, toolkit) => {
    return await AxiosClient('GET', '/api/billing-plan', [], toolkit, params)
  }
)

export const getUserPlanAsync = createAsyncThunk(
  'auth/getUserPlanAsync',
  async (payload, toolkit) => {
    return await AxiosClient('GET', '/api/activate-billing-plan/', [], toolkit, [])
  }
)

export const getBillingCycleOrderCountsAsync = createAsyncThunk(
  'auth/getBillingCycleOrderCountsAsync',
  async (_: void, toolkit) => {
    return await AxiosClient(
      'GET',
      BILLING_CYCLE_ORDER_COUNTS_PATH,
      [],
      toolkit,
      [],
      toolkit.signal
    )
  }
)

//approval
export const getApproveSubscriptionAsync = createAsyncThunk(
  'auth/getApproveSubscriptionAsync',
  async (params: any, toolkit) => {
    return await AxiosClient('GET', `/api/approve-subscription`, [], toolkit, params)
  }
)

//get custom price plans
export const getCustomPlansAsync = createAsyncThunk(
  'auth/getCustomPlansAsync',
  async (params: any, toolkit) => {
    return await AxiosClient('GET', `/superadmin/custom-plan`, [], toolkit, params)
  }
)

export const createCustomPlanAsync = createAsyncThunk(
  'auth/createCustomPlanAsync',
  async (payload: any, toolkit) => {
    return await AxiosClient('POST', `/superadmin/custom-plan`, payload, toolkit, [])
  }
)

export const updateCustomPlanAsync = createAsyncThunk(
  'auth/updateCustomPlanAsync',
  async (
    payload: {
      billing_plan_id: number
      user_id: number
      product_limit: number | string
      order_limit: number | string
      billing_frequency?: string
      price?: number | string
    },
    toolkit
  ) => {
    const {billing_plan_id, ...body} = payload
    return await AxiosClient('PUT', `/superadmin/custom-plan-update/${billing_plan_id}`, body, toolkit, [])
  }
)

export const getBillingPlatformId = createAsyncThunk(
  'auth/getBillingPlatformId',
  async (params: any, toolkit) => {
    return await AxiosClient('GET', `/api/billing-platform`, [], toolkit, params)
  }
)

export const approvePaypalSubscriptionAsync = createAsyncThunk(
  'auth/approvePaypalSubscriptionAsync',
  async (params: any, toolkit) => {
    return await AxiosClient('POST', '/api/paypal-approve-subscription', [], toolkit, params)
  }
)

export const logPaypalSubscriptionAsync = createAsyncThunk(
  'auth/logPaypalSubscriptionAsync',
  async (payload: any, toolkit) => {
    return await AxiosClient('POST', '/api/subscription-log', payload, toolkit, [])
  }
)
